export default function Scale(num, in_min, in_max) {
  return ((num - in_min) * (120 - -120)) / (in_max - in_min) + -120;
}
